import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{#let (element (or-else @as \"div\")) as |Element|}}\n  <Element class={{this.classnames}} {{css-vars this.style}} ...attributes>\n    {{yield}}\n  </Element>\n{{/let}}")